import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonSettingsInterface } from '@zaoblako/shared/modules/saas/dtos/common-settings.dto';
import { BasisSaasCommonSettingsService } from '@zaoblako/web/core/services/basis/basis-saas-common-settings.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'crm-common-settings-card',
  standalone: true,
  imports: [CommonModule, CardModule, CheckboxModule, FormsModule, SpinnerComponent],
  templateUrl: './common-settings-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonSettingsCardComponent implements OnInit {
  public loading = true;
  public commonSettings: CommonSettingsInterface;

  public constructor(
    private readonly basisSaasCommonSettingsService: BasisSaasCommonSettingsService,
    private readonly globalService: GlobalService,
    private readonly errorService: ErrorService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    forkJoin([this.basisSaasCommonSettingsService.getCommonSettings()]).subscribe(([commonSettings]) => {
      this.commonSettings = commonSettings;
      this.loading = false;
      this.cdRef.markForCheck();
    });
  }

  public changeCommonSettings(): void {
    this.basisSaasCommonSettingsService.setCommonSettings(this.commonSettings).subscribe({
      next: () => {
        this.globalService.updateCommonSettings(this.commonSettings);
        this.errorService.addSuccessMessage('Изменения сохранены');
      }
    });
  }
}
